export interface IImageProps {
    text?: string,
    rotateOnLeave: number,
    top: number,
    left?: number,
    right?: number,
    isHover?: boolean,
}

export const imagesParams: IImageProps[] = [
    {
        text: 'Домофон',
        rotateOnLeave: -19.75,
        top: -25,
        left: 92,
    },
    {
        text: 'Интернет',
        rotateOnLeave: 19.56,
        top: -23,
        right: 5,
    },
    {
        text: 'Видеонаблюдение',
        rotateOnLeave: 15,
        top: 38,
        left: 88,
    },
    {
        text: 'ТВ',
        rotateOnLeave: -23.5,
        top: 32,
        right: 5,
    },
];
